module.exports = __webpack_public_path__ + "img/kuraray_PPT2_JP.6a38b4bd.jpg";